<ng-container *ngIf="uploadProgress$ | async as uploadProgress">
  <h1 *ngIf="uploadProgress !== 100" mat-dialog-title>
    Téléversement En Cours
  </h1>
  <h1 *ngIf="uploadProgress === 100" mat-dialog-title>
    Téléversement Terminé!
  </h1>
  <div mat-dialog-content>
    <p *ngIf="uploadProgress !== 100">
      Veuillez Patienter, vos fichier sont en cours de transfert
    </p>
    <p *ngIf="uploadProgress === 100">Merci, vous pouvez fermer la fenêtre</p>
    <mat-progress-bar
      class="progress-bar"
      mode="determinate"
      [value]="uploadProgress"
    >
    </mat-progress-bar>
  </div>
  <div *ngIf="uploadProgress === 100" mat-dialog-actions>
    <button
      type="button"
      mat-raised-button
      color="primary"
      [mat-dialog-close]="true"
    >
      Fermer
    </button>
  </div>
</ng-container>
